<template>
    <vl-sidebar-content class="kl-sidebar__section" :class="{'only-1-section': only1Section}">
        <div class="kl-sidebar__section__edit-zone-detail">
            <div class="kl-sidebar__section__edit-zone-detail__col1">
                <strong class="kl-sidebar__text13">OPPERVLAKTE</strong>
                <div v-html="currentPolygonFeatureAreaFormatted"></div>
            </div>
            <div class="kl-sidebar__section__vertical-separator"></div>
            <div class="kl-sidebar__section__edit-zone-detail__col2" v-if="!currentZoneError">
                <span v-html="currentZoneDetailInfo" v-if="currentZoneDetailInfo"></span>
            </div>
            <div class="kl-sidebar__section__vertical-separator" v-if="!currentZoneError && currentZonePrice"></div>
            <div class="kl-sidebar__section__edit-zone-detail__col3" v-if="!currentZoneError && currentZonePrice">
                <strong>{{ formatCurrency(currentZonePrice) }}</strong>
            </div>
            <!-- ERROR -->
            <div class="kl-sidebar__section__edit-zone-detail__col-error" v-if="currentZoneError">
                <vl-icon icon="alert-triangle-filled" mod-large/>
                <span v-vl-text.bold.small.error>{{ currentZoneError }}</span>
            </div>
        </div>
    </vl-sidebar-content>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {useFormatting} from '@/composables/formatting';

export default defineComponent({
    name: 'KlDrawZoneSidebarEditZoneDetail',
    props: {
        currentPolygonFeatureAreaFormatted: {
            type: String,
            default: undefined,
        },
        currentZoneDetailInfo: {
            type: String,
            default: undefined,
        },
        currentZoneError: {
            type: String,
            default: undefined,
        },
        currentZonePrice: {
            type: Number,
            default: undefined,
        },
        only1Section: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const {formatCurrency} = useFormatting();

        return {
            formatCurrency
        }
    }
});
</script>

<style scoped>
/* Add scoped styles here if needed */
</style>
